import React from 'react'
import DeleteRowIconSVG from "../../../assets/icons/delete-row-button.svg"
export const DeleteRowIcon: React.FC = () => {
  return (
    <img role="button" src={DeleteRowIconSVG} alt="" className="w-[16px] h-[16px]" />
  )
}
